import styled from '@emotion/styled';
import { BaseButton, Variables } from '../../../base';

export const Container = styled.div`
    margin-left: 8px;
    display: inline-flex;
    align-items: center;
`;

export const ActionButton = styled(BaseButton)`
    min-width: auto;
    fill: ${Variables.ThemeLight.TextMild};
    height: 30px;
    width: auto;
    min-width: 40px;
    border-color: transparent;
    background: none;
    gap: 2px;
    padding: 0 6px;
    svg {
        fill: ${Variables.ThemeLight.TextMild};
    }

    &:hover {
        fill: ${Variables.Colors.n70};
        background: white;
        border: solid 1px ${Variables.Colors.nx8};
    }

    z-index: 1;
`;

export const IconOnlyActionButton = styled(ActionButton)`
    width: 40px;
    padding: 0;
`;

export const ExportAllLabel = styled.span`
    font-size: 11px;
    font-weight: 600;
    color: ${Variables.ThemeLight.TextMild};
    line-height: 1;
`;
